import { DayViewEvent, Visit } from "../scheduleApi"
import EventSelectCrew from "../EventSelectCrew"
import AvatarGroup from "./AvatarGroup"

type Props = {
  event: DayViewEvent
  visit: Visit | null
}

const DayViewEventAvatar = ({ event, visit }: Props) => {
  const editable = !visit

  return <div style={{ display: 'flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
    {!editable ? (
      <AvatarGroup crewForemanEmail={event.crewForemanEmail} crewMemberIds={event.crewMemberIds} />
    ) : (
      <EventSelectCrew event={event} variant="pill" />
    )}
  </div>
}

export default DayViewEventAvatar